import React from 'react';
import UserCard from './UserCard';
import { CeDealershipV1, DealershipUserV1 } from '../../services/dealerships/types';

const NoUsers = () => (
  <div className="border border-black bg-white rounded-lg p-4 text-center text-gray-600">
    <p>No users found.</p>
  </div>
);

interface UserListProps {
  dealership: CeDealershipV1 | undefined;
  onUserSelect?: (user: DealershipUserV1) => void;
  onUserClickDelete?: (user: DealershipUserV1, dealership: CeDealershipV1) => void;
}

const UserList: React.FC<UserListProps> = ({ dealership, onUserSelect, onUserClickDelete }) => {
  const users = dealership?.users;
  const guaranteeDealershipUserV1: DealershipUserV1[] = users ?? [];
  const handleUserClick = (user: DealershipUserV1) => {
    if (onUserSelect) {
      onUserSelect(user); // Notify parent
    }
  };
  const handleUserDelete = (user: DealershipUserV1, dealership: CeDealershipV1) => {
    if (onUserClickDelete) {
      onUserClickDelete(user, dealership); // Notify parent
    }
  };
  return (
    <div className="mb-10">
      <h3 className="font-medium text-xl mb-2">Members</h3>
      <div className="flex flex-wrap gap-4">
        {guaranteeDealershipUserV1.length > 0 ? (
          users?.map((user, index) => (
            <UserCard
              key={index}
              {...user}
              onClick={() => handleUserClick(user)}
              onClickDelete={() => handleUserDelete(user, dealership ?? {})}
            />
          ))
        ) : (
          <NoUsers />
        )}
      </div>
    </div>
  );
};

export default UserList;
